module.exports = {
  fr: {
    summary: "Récapitulatif de votre trajet",
    title: "Référence",
    startPlace: "Prise en charge",
    startDate: "Départ",
    passengers: "Passagers",
    bagages: "Bagages",
    toPlace: "Destination",
    toDate: "Retour",
    price: "Prix",
  },
  en: {
    summary: "Your trip summary",
    title: "Reference",
    startPlace: "Pick-up",
    startDate: "Departure",
    passengers: "Passengers",
    bagages: "Luggage",
    toPlace: "Destination",
    toDate: "Return",
    price: "Price",
  },
  ru: {
    summary: "Детали поездки",
    title: "Номер",
    startPlace: "Место посадки",
    startDate: "Отправление",
    passengers: "Пассажиры",
    bagages: "Багаж",
    toPlace: "Пункт назначения",
    toDate: "Возвращение",
    price: "Стоимость",
  },
};
